// import { EPollType as EPollTypeOriginal } from '@pushflow/types/'

// export const EPollType = EPollTypeOriginal
// export type EPollType = (typeof EPollTypeOriginal)[keyof typeof EPollTypeOriginal]

// TODO: packages/types/common/enums/EPollType.ts
export enum EPollType {
  DOUBLE_BOARD = 'DOUBLE_BOARD',
}
